import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import { Btn, Chip, Field, Page, Spinner, TopBar } from "@/components/kit";
import { useCategories, useContact, useUpdateContact } from "@/hooks/queries";

export const CONTACT_FIELDS = [
  ["name", "Full Name"], ["designation", "Designation"], ["companyName", "Company"], ["phone", "Mobile", "tel"],
  ["alternatePhone", "Alternate Mobile", "tel"], ["whatsapp", "WhatsApp", "tel"], ["email", "Email", "email"],
  ["website", "Website", "url"], ["address", "Address"], ["area", "Area"], ["city", "City"], ["state", "State"],
  ["country", "Country"], ["postalCode", "Postal Code"], ["notes", "Notes"],
];

export function CategoryPicker({ value, onChange, prefix }) {
  const cats = useCategories().data ?? [];
  return (
    <div className="flex flex-wrap gap-2">
      {cats.map((c) => <Chip key={c.id} selected={value === c.name} onClick={() => onChange(value === c.name ? "" : c.name)} testid={`${prefix}-category-${c.slug}`}>{c.name}</Chip>)}
    </div>
  );
}

export function ContactFields({ form, setForm, keys, flagged = {}, prefix }) {
  return (
    <div className="grid gap-4 sm:grid-cols-2">
      {CONTACT_FIELDS.map(([k, label, type]) => {
        const key = keys?.[k] ?? k;
        const wide = k === "notes" || k === "address";
        return (
          <div key={k} className={wide ? "sm:col-span-2" : ""}>
            <Field label={label} type={type === "email" ? "email" : "text"} inputMode={type === "tel" ? "tel" : undefined} textarea={wide} value={form[key] ?? ""}
              onChange={(e) => setForm((f) => ({ ...f, [key]: e.target.value }))} testid={`${prefix}-field-${key}`} className={flagged[key] ? "[&_.t-input]:border-[#F59E0B] [&_.t-input]:bg-[#FFFBEB]" : ""} />
            {flagged[key] && <p className="mt-1 text-[12px] font-medium text-[#B54708]">Please verify this field</p>}
          </div>
        );
      })}
    </div>
  );
}

export default function EditContact() {
  const { id } = useParams();
  const nav = useNavigate();
  const { data: c } = useContact(id);
  const cats = useCategories().data;
  const update = useUpdateContact(id);
  const [form, setForm] = useState(null);
  const [category, setCategory] = useState("");

  useEffect(() => {
    if (c && cats && !form) {
      setForm(Object.fromEntries(CONTACT_FIELDS.map(([k]) => [k, c[k] ?? ""])));
      setCategory(cats.find((x) => x.id === c.categoryId)?.name ?? "");
    }
  }, [c, cats, form]);

  if (!form) return <Spinner />;
  const save = async () => {
    if (!form.name?.trim() && !form.companyName?.trim()) return toast.error("Please provide at least a name or company.");
    try {
      await update.mutateAsync({ ...form, category });
      toast.success("Contact updated.");
      nav(`/contacts/${id}`);
    } catch (e) {
      toast.error(e.message || "Could not save changes.");
    }
  };
  return (
    <Page>
      <TopBar title="Edit Contact" />
      <h2 className="t-section mt-2 mb-3">Category</h2>
      <CategoryPicker value={category} onChange={setCategory} prefix="edit" />
      <div className="mt-6"><ContactFields form={form} setForm={setForm} prefix="edit" /></div>
      <Btn className="w-full mt-8" onClick={save} loading={update.isPending} testid="edit-contact-save">Save Changes</Btn>
    </Page>
  );
}
